<template>
    <div v-if="hasAuth('Admin')">
        <list-container :header="translate('remInboxList.remAccounts')" v-show="!$route.params.id">
            <template v-slot:commands>
                <excel-exporter table-id="remproviderExport" :columns="columns" url="/remprovider/get" modelName="RemProvider"  orderBy="RemAddress"></excel-exporter>
                <button v-if="hasModule('REM')" class="btn btn-primary" @click="$router.push({ name:'RemProviderDetail', params: { id: '000000000000000000000000' } })">
                    {{translate('remInboxList.newREMAccount')}}
                </button>
            </template>
            <list :columns="columns" url="/remprovider/get" modelName="RemProvider"  orderBy="IsActive desc, RemAddress">

            </list>
        </list-container>
        <router-view v-if="$route.params.id"/>
    </div>
    <div v-else class="alert alert-danger">
        {{translate('errors.notAuthorizedForTheProcess')}}
    </div>
</template>

<script>
import Vue from 'vue'
import list from '../components/List.vue'
import listContainer from '../components/ListContainer.vue'
import ExcelExporter from '../components/ExcelExporter.vue';


export default {
    data(){
        return {
            columns : [
                {
                    Key: "Name",
                    Title: this.translate('categoryList.columns.name'),
                    SortField: "Name"
                },
                {
                    Key: "RemAddress",
                    Title: this.translate('targetSystem.rem.remAddress'),
                    SortField: "RemAddress"
                },
                {
                    Key: "IsActive",
                    Title: this.translate('categoryList.columns.active'),
                    SortField: "IsActive",
                    Class: "text-center",
                    Content(i) {
                        return Vue.filter('checkicon')(i.IsActive);
                    }
                }
            ]
        }
    },
    components: {
        list,ExcelExporter,
        listContainer
    },
    methods: {
        // select(i){
        //     console.log('Kayıt seçildi: ', i);
        //     this.$router.push('draft/' + i.Id);
        // }
    }
}
</script>